<template>
  <div class="version border-top text-nowrap" :class="{ 'gestor': gestor, 'fixed': fixed }">
    Gestor web: <b>{{ app_version }}</b> <span v-if="electronV"><span class="mx-1">|</span> Desktop: <b>{{ electronV | version }}</b></span>
  </div>
</template>

<script>
export default {
  name: "VersionApp",
  props: ['gestor', 'fixed'],
  filters: {
    version(v) {
      return (v || '').toString().split("").join(".");
    }
  }
}
</script>

<style scoped>
.version {
  background-color: #ffffff;
  position: absolute;
  bottom: 0;
  font-size: 75%;
  padding: 2px 15px;
  width: 100%;
  text-align: center;

}

.version.fixed {
  position: fixed;
  z-index: 1;
}

@media (min-width: 768px) {
  .version.gestor {
    width: calc(100% - 70px);
    left: 70px;
  }
}
</style>